export default class formConfig {
  // 邀请确认
  static configList() {
    return [
      {
        title: "中标项目基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目名称",
            value: "constructionPrjName",
            children: [
              {
                label: "项目编号",
                value: "constructionNo",
              },
            ]
          },
          {
            label: "招标项目名称",
            value: "prjName",
            children: [
              {
                label: "招标编码",
                value: "tenderReference",
              },
              {
                label: "标段号",
                value: "section",
              },
            ]
          },
          {
            label: "招标内容",
            value: "tenderContent",
          },
          {
            label: "招标方式",
            value: "tenderTypeName",
            children: [
              {
                label: "招标类别",
                value: "tenderClassName",
              },
            ]
          },
          {
            label: "开标时间",
            value: "reserveStartTime",
            children: [
              {
                label: "开标地点",
                value: "openingPlace",
              },
            ]
          },
          {
            label: "评标时间",
            value: "evaluationStartDate",
            children: [
              {
                label: "评标地点",
                value: "reviewAdd",
              },
            ]
          },
        ]
      },
      {
        title: "放弃中标候选人信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "中标候选人",
            value: "basicInfoName",
            children: [
              {
                label: "中标价（万元）",
                value: "winningPrice",
              },
              {
                label: "中标名次",
                value: "winningRanking",
              },
            ]
          },
          {
            label: "质量标准",
            value: "qualityStandard",
            children: [
              {
                label: "中标工期(日历天)",
                value: "winningLimit",
              },
              {
                label: "安全防护、文明施工及环境保护费",
                value: "securityCivilizationFee",
              },
            ]
          },
          {
            label: "放弃中标说明",
            value: "giveUpExplain",
          }
        ]
      },
    ];
  }
}
